import { render, staticRenderFns } from "./PspCosteo.vue?vue&type=template&id=1e9b28e8"
import script from "./PspCosteo.vue?vue&type=script&lang=js"
export * from "./PspCosteo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports